import { useQuery, useQueryClient } from "@tanstack/react-query";

import { getFootprintingPorkPrimaryDataById, getFootprintingPorkPrimaryDataByIdAdmin } from "services";

import { getEnvironment, shouldRetryQueryError } from "utils";

import { FOOTPRINTING_PORK_PRIMARY_DATA } from "consts";

export const useGetFootprintingPorkPrimaryDataById = (primaryDataId: string, { enabled = true } = {}) => {
  const isAdmin = getEnvironment().admin;
  const queryClient = useQueryClient();

  return useQuery(
    {
      queryKey: [FOOTPRINTING_PORK_PRIMARY_DATA, primaryDataId, isAdmin],
      queryFn: () => (isAdmin ? getFootprintingPorkPrimaryDataByIdAdmin(primaryDataId) : getFootprintingPorkPrimaryDataById(primaryDataId)),
      enabled: enabled && !!primaryDataId,
      gcTime: 60000,
      retry: shouldRetryQueryError(),
    },
    queryClient
  );
};
